import { BlobPicture } from "../Models/BlobPicture";
import { IOnlineStorage } from "./IOnlineStorage";


export class DemoOnlineStorage implements IOnlineStorage
{
    public Url = "";

    public async SaveBlob(picture: BlobPicture, fileName: string, folder: string): Promise<boolean>
    {
        alert('W sesji demo zdjęcia nie są zapisywane na serwerze!');
        return false;
    }
}
